export const generateURLParams = (params: object): any => {
  let urlParams = '';
  if (!params) {
    return urlParams;
  }
  let first = true;
  for (const key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] !== 'undefined') {
      let value = '';
      if (Array.isArray(params[key])) {
        value = params[key].join(',');
      }
      else if (params[key] === null) {
        value = '';
      }
      else if (typeof params[key] === 'object') {
        value = JSON.stringify(params[key]);
      }
      else {
        value = params[key]?.toString();
      }

      urlParams += (first ? '?' : '&') + key + '=' + value;
      first = false;
    }
  }
  return urlParams;
};
